import { render, staticRenderFns } from "./LibraryFileTable.vue?vue&type=template&id=90864060"
import script from "./LibraryFileTable.vue?vue&type=script&lang=js"
export * from "./LibraryFileTable.vue?vue&type=script&lang=js"
import style0 from "./LibraryFileTable.vue?vue&type=style&index=0&id=90864060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LibraryFileTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports